// Core
import React, { CSSProperties } from 'react';

import { PaletteKeyColorNames, styled } from '@spazious/dollhouse-theme';

export interface SvgIconProps extends React.SVGAttributes<SVGSVGElement> {
  /**
   *
   */
  size?: 'large' | 'medium' | 'small' | number;
  /**
   *
   */
  color?: PaletteKeyColorNames;
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox?: string;

  fontSize?: CSSProperties['fontSize'];
}

export const SvgIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(
  ({ children, viewBox = '0 0 24 24', ...restProps }, ref) => {
    return (
      <svg ref={ref} viewBox={viewBox} {...restProps}>
        {children}
      </svg>
    );
  }
);

export default styled(SvgIcon).withConfig({
  shouldForwardProp: (prop) => !['color', 'size'].includes(prop as any),
  displayName: 'SvgIcon',
})`
  font-size: ${({ fontSize = '24px', size }) =>
    typeof size === 'number' ? `${size}px` : fontSize};
  user-select: none;
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  flex-shrink: 0;
`;
